import React from 'react';
import { useAnimatedClose } from './hooks/useAnimatedClose';

type PageShellProps = {
  contextLabel?: React.ReactNode;
  title?: React.ReactNode;
  onClose?: () => void;
  closeDisabled?: boolean;
  alert?: React.ReactNode;
  preview?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  width?: number | string;
  className?: string;
  testId?: string;
  framed?: boolean;
};

function PageShell({
  contextLabel,
  title,
  onClose,
  closeDisabled = false,
  alert,
  preview,
  children,
  footer,
  width,
  className,
  testId,
  framed = true
}: PageShellProps) {
  const hasPreview = preview !== undefined && preview !== null;
  const { close, isClosing } = useAnimatedClose(onClose);

  return (
    <div
      className={`page-shell${framed ? '' : ' page-shell--frameless'}${isClosing ? ' page-slide-out' : ''}${className ? ` ${className}` : ''}`}
      style={width ? { width } : undefined}
      data-testid={testId || undefined}
    >
      <div className="page-shell-header">
        <div>
          {contextLabel && <p className="muted" style={{ margin: 0, fontWeight: 600 }}>{contextLabel}</p>}
          <h1 className="page-shell-title">{title}</h1>
        </div>
        {onClose ? (
          <button className="subtle-btn" onClick={close} disabled={closeDisabled} data-testid={testId ? `${testId}-close` : undefined}>Back</button>
        ) : null}
      </div>

      <div className={`drawer-body${hasPreview ? '' : ' no-preview'}`} style={{gridTemplateColumns: "minmax(0, 1fr) minmax(0, 2fr)"}} >
        <div className="drawer-preview">{preview}</div>
        <div className="drawer-controls">
          <div className="drawer-controls-card">
            {alert}
            {children}
            {footer}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(PageShell);
